<template>
  <div>
    <div>
      <div class="welcome" style="border: 0px solid red;">
        <row
          style="border:0px solid green;position: inherit;display:contents;width:100%;"
        >
          <div class="box box-success" v-if="onTabSelect === 0">
            <div class="box-header with-border">
              <h3 class="box-title">{{ $t("search.title") }}</h3>
            </div>

            <div class="box-body">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-4 col-md-3 col-lg-3">
                  <div class="form-group">
                    <div class="input-group">
                      <span class="input-group-addon">
                        <i class="fa fa-gears"></i>
                      </span>
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('common.search')"
                        v-model="search.assetCodeAndName"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3">
                  <div class="form-group">
                    <v-select
                      class="clear"
                      :options="supplierList"
                      :getOptionLabel="option => option.name"
                      :reduce="data => data.id"
                      label="text"
                      :placeholder="$t('property.asset.provider')"
                      :filter="onSearchSupplier"
                      v-model="search.supplierId"
                    >
                      <template v-slot:option="option">
                        {{ $t(option.name) }}
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3">
                  <div class="form-group">
                    <b-form-select
                      :options="assetStatusList"
                      :placeholder="$t('property.asset.status')"
                      v-model="search.status"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3">
                  <div class="form-group">
                    <b-form-select
                      :options="assetTypeItems"
                      :placeholder="$t('property.asset.status')"
                      v-model="search.assetType"
                      class="form-control"
                    />
                  </div>
                </div>
              <!-- </div>
              <div class="row" style="margin-bottom: 10px;"> -->
                <div class="col-sm-4 col-md-3 col-lg-3">
                  <div class="form-group">
                    <div class="input-group date">
                      <div class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <date-picker
                        v-model="search.maintainance_start_date"
                        :config="options"
                        :placeholder="$t('property.asset.lastMaintenanceDate')"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3">
                  <div class="form-group">
                    <div class="input-group date">
                      <div class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <date-picker
                        v-model="search.nextMaintainanceDate"
                        :config="options"
                        :placeholder="$t('property.asset.nextMaintainanceDate')"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3">
                  <div class="form-group">
                    <v-select
                      class="clear"
                      :options="departmentList"
                      :reduce="data => data.id"
                      :getOptionLabel="option => $t(option.name)"
                      v-model="search.unitsUsed"
                      :placeholder="$t('property.asset.unitsUsed')"
                    >
                      <template v-slot:option="option">
                        {{ option.name }}
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('property.asset.manufacturingDate')"
                      v-model="search.manufacturingDate"
                    />
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-3 col-md-3 col-lg-3"></div>
                <div class="col-sm-3 col-md-3 col-lg-3"></div>
                <div class="col-sm-3 col-md-3 col-lg-3"></div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <button
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    @click="onSearch()"
                  >
                    <span class="btn-label">
                      <i class="glyphicon glyphicon-search"></i>
                    </span>
                    {{ $t("search.search_button") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="box box-success" v-if="onTabSelect === 1">
            <div class="box-header with-border">
              <h3 class="box-title">{{ $t("search.title") }}</h3>
            </div>
            <div class="box-body">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="fa fa-font"></i>
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('common.search')"
                      v-model="supplierSearch.searchText"
                    />
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-3 col-md-3 col-lg-3"></div>
                <div class="col-sm-3 col-md-3 col-lg-3"></div>
                <div class="col-sm-3 col-md-3 col-lg-3"></div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <button
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    @click="onSearch()"
                  >
                    <span class="btn-label">
                      <i class="glyphicon glyphicon-search"></i>
                    </span>
                    {{ $t("search.search_button") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- body -->
          <div class="box box-success">
            <div style="margin-top: 5px">
              <ul class="nav nav-tabs">
                <li class="active" @click="onClickTabSelect(0)">
                  <a data-toggle="tab" href="#assetListV2"
                    ><b>{{ $t("property.asset.title") }}</b></a
                  >
                </li>
                <li @click="onClickTabSelect(1)">
                  <a data-toggle="tab" href="#supplierManagement"
                    ><b>{{ $t("supplierManagement.title") }}</b></a
                  >
                </li>
              </ul>

              <div class="tab-content">
                <div id="assetListV2" class="tab-pane fade in active">
                  <asset-list-v2 ref="assetListV2Ref" />
                </div>
                <div id="supplierManagement" class="tab-pane fade">
                  <supplier-management ref="supplierManagementRef" />
                </div>
              </div>
            </div>
          </div>
        </row>
      </div>
    </div>
  </div>
</template>
<script>
import AssetListV2 from "./AssetListV2";
import SupplierManagement from "./SupplierManagement";
//
import datePicker from "vue-bootstrap-datetimepicker";
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
export default {
  components: {
    "date-picker": datePicker,
    AssetListV2,
    SupplierManagement
  },
  data: () => ({
    options: {
      format: "YYYY-MM-DD"
    },
    dateOptions: {
      format: "DD-MM-YYYY"
    },
    search: {
      assetCodeAndName: "",
      location: "",
      maintenancePersonnel: "",
      status: "",
      maintainance_start_date: "",
      nextMaintainanceDate: "",
      assetType: "",
      unitsUsed: null,
      supplierId: null,
      manufacturingDate: null
    },
    supplierSearch: {
      searchText: null
    },
    onTabSelect: 0,
    assetStatusList: [],
    assetTypeItems: [],
    departmentList: [],
    supplierList: []
  }),
  watch: {
    GET_ASSET_TYPE_LIST_DATA: function() {
      let data = this.GET_ASSET_TYPE_LIST_DATA;
      this.assetTypeItems = [
        { value: "", text: this.$t("property.asset.type"), disabled: true },
        { value: null, text: "---" }
      ];
      data.forEach((value, i) => {
        let item = {
          value: value.id,
          text: value.name
        };
        this.assetTypeItems.push(item);
      });
    },
    GET_DEPARTMENT_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_DEPARTMENT_LIST_NO_PAGE_DATA;
      this.departmentList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          name: value.name
        };
        this.departmentList.push(item);
      });
    },
    GET_ASSET_SUPPLIER_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_ASSET_SUPPLIER_LIST_NO_PAGE_DATA;
      this.supplierList = [];
      data.forEach(e => {
        let item = {
          id: e.id,
          name: e.name
        };
        this.supplierList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ASSET_TYPE_LIST_DATA",
      "GET_DEPARTMENT_LIST_NO_PAGE_DATA",
      "GET_ASSET_SUPPLIER_LIST_NO_PAGE_DATA"
    ])
  },
  methods: {
    onSearchSupplier: function(options, search) {
      let resultSearch = options.filter(
        x =>
          utils.replaceCharactersVNLanguage(x.name.toLowerCase()).includes(
            utils.replaceCharactersVNLanguage(search.toLowerCase()))
      );
      return search.length > 0 && resultSearch.length > 0 ? resultSearch : [];
    },
    getAssetTypeList: function() {
      this.GET_ASSET_TYPE_LIST();
    },
    getDepartmentList: function() {
      this.GET_DEPARTMENT_LIST();
    },
    onSearch: function() {
      const data = {
        assetCodeAndName: utils.getCleanStringValue(this.search.assetCodeAndName),
        location: utils.getCleanStringValue(this.search.location),
        maintenancePersonnel: utils.getCleanStringValue(this.search.maintenancePersonnel),
        status: utils.getCleanStringValue(this.search.status),
        lastMaintainanceDate: utils.getCleanStringValue(this.search.maintainance_start_date),
        nextMaintainanceDate: utils.getCleanStringValue(this.search.nextMaintainanceDate),
        assetType: utils.getCleanStringValue(this.search.assetType),
        unitsUsed: utils.getCleanStringValue(this.search.unitsUsed),
        supplierId: this.search.supplierId,
        manufacturingDate: utils.getCleanStringValue(this.search.manufacturingDate)
      };
      let filter = {
        searchText: this.supplierSearch.searchText
      };
      switch (this.onTabSelect) {
        case 0:
          this.$refs.assetListV2Ref.refreshData(data);
          break;
        case 1:
          this.$refs.supplierManagementRef.refreshData(filter);
          break;
        default:
          break;
      }
    },
    onClickTabSelect: function(value) {
      this.onTabSelect = value;
      this.onSearch();
    },
    getAssetSupplierList: function(searchText) {
      this.isLoading = true;
      let filter = {
        params: {
          searchText: searchText
        }
      };
      this.isLoading = true;
      this.GET_ASSET_SUPPLIER_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    ...mapActions([
      "GET_ASSET_STATUS_LIST",
      "GET_ASSET_TYPE_LIST",
      "GET_DEPARTMENT_LIST",
      "GET_ASSET_SUPPLIER_LIST"
    ])
  },
  async mounted() {
    // get asset status
    await this.GET_ASSET_STATUS_LIST().then(
      function(res) {
        let getStatusAssetDataList = res.data;
        let getStatusList = [
          { value: "", text: this.$t("property.asset.status"), disabled: true },
          { value: null, text: "---" }
        ];

        getStatusAssetDataList.forEach(item => {
          const data = {
            value: item.id,
            text: item.name
          };
          getStatusList.push(data);
        });
        this.assetStatusList = getStatusList;
      }.bind(this)
    );
    await this.getAssetTypeList();
    await this.getDepartmentList();
    await this.getAssetSupplierList()
  }
};
</script>
<style lang="scss" scoped>
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  background: #337ab7;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/Property/AssetTabs.vue